// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detalle {
  background-color: #539cad;
  color: white;
  margin: 12px 8px;
  min-height: 150px;
  border-radius: 5px;
}
.detalle .detalle-title {
  border-radius: 5px 5px 0 0;
  padding: 4px 8px;
  background-color: #023b48;
  font-weight: 500;
}
.detalle .detalle-title .fas.txt-20 {
  position: relative !important;
  top: 10px !important;
}
.detalle .detalle-title .fas.fa-star {
  position: relative !important;
  top: 0 !important;
  left: 7px !important;
}
.detalle .detalle-body {
  white-space: pre-wrap;
  padding: 8px;
  font-size: 1.15rem;
}`, "",{"version":3,"sources":["webpack://./src/app/modulos/crm/components/trato/trato-principal/detalle-card/detalle-card.component.scss","webpack://./src/assets/css/colores.scss"],"names":[],"mappings":"AAEA;EACC,yBCIiB;EDHjB,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AADD;AAGC;EACC,0BAAA;EACA,gBAAA;EACA,yBCNgB;EDOhB,gBAAA;AADF;AAEE;EACC,6BAAA;EACA,oBAAA;AAAH;AAEE;EACC,6BAAA;EACA,iBAAA;EACA,oBAAA;AAAH;AAGC;EACC,qBAAA;EACA,YAAA;EACA,kBAAA;AADF","sourcesContent":["@import \"../../../../../../../assets/css/colores.scss\";\r\n\r\n.detalle {\r\n\tbackground-color: $oa-secundario3;\r\n\tcolor: white;\r\n\tmargin: 12px 8px;\r\n\tmin-height: 150px;\r\n\tborder-radius: 5px;\r\n\r\n\t.detalle-title {\r\n\t\tborder-radius: 5px 5px 0 0 ;\r\n\t\tpadding: 4px 8px;\r\n\t\tbackground-color: $oa-secundario2;\r\n\t\tfont-weight: 500;\r\n\t\t.fas.txt-20{\r\n\t\t\tposition: relative !important;\r\n\t\t\ttop:10px !important;\r\n\t\t}\r\n\t\t.fas.fa-star{\r\n\t\t\tposition: relative !important;\r\n\t\t\ttop: 0 !important;\r\n\t\t\tleft: 7px !important;\r\n\t\t}\r\n\t}\r\n\t.detalle-body {\r\n\t\twhite-space:pre-wrap;\r\n\t\tpadding:8px;\r\n\t\tfont-size: 1.15rem;\r\n\t}\r\n}\r\n","\r\n$oa-principal : #d20a31;\r\n$oa-principal2 : #6d0015;\r\n$oa-principal3 : #f06f88;\r\n\r\n$oa-secundario : #0a738c;\r\n$oa-secundario2 : #023b48;\r\n$oa-secundario3 : #539cad;\r\n\r\n$oa-accent : #46c309;\r\n$oa-accent2 : #216500;\r\n$oa-accent3 : #90e268;\r\n\r\n$oa-accent-secundario : #E1750B;\r\n$oa-accent-secundario2 : #753A00;\r\n$oa-accent-secundario3 : #FFBA76;\r\n\r\n$oa-background : #023b48;\r\n\r\n$oa-blanco-bg : white;\r\n$oa-blanco : white;\r\n\r\n$oa-gris : #6e6e6e;\r\n$oa-gris-claro : #a3a3a3;\r\n$oa-gris-oscuro : #424242;\r\n\r\n$oa-color-link: #3e92ff;\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
